import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import uniqid from 'uniqid';
import Button from './Button';
import BodyBlocker from "./BodyBlocker";
import { dialogClose } from '../actions/creators/dialogs'

const Modal = styled.div`
  background: #FFFFFF;
  color: #000000;
  left: 50%;
  max-width: 500px;
  position: fixed;
  text-align: center;
  top: 50%;
  transform: translate(-50%,-50%);
  width: 90%;
  z-index: ${props => props.theme.zIndexes.dialogs};

  body.theme-platinum & {
    background: var(--text-primary);
  }
`;

export interface DialogProps {
    id?: string,
    emoji?: string,
    icon?: string,
    buttons?: {
        label: string,
        onClick: Function,
        primary?: boolean,
        [key: string]: any,
    }[],
    message: string,
    easyClose?: boolean,
};

type Props = {
    dialogs: {
        [key: string]: DialogProps,
    },
    dialogClose: Function,
};

class Dialogs extends React.Component<Props> {
    constructor(props) {
        super(props);

        this.bgClick = this.bgClick.bind(this);
    }

    bgClick() {
        const { dialogs } = this.props;
        const ids = Object.keys(dialogs);
        const lastDialog = dialogs[ids[ids.length - 1]];

        if (lastDialog.easyClose) {
            this.props.dialogClose(lastDialog.id);
        }
    }

    render() {
        const ids = Object.keys(this.props.dialogs);
        if (!ids.length) {
            return '';
        }

        // @todo Fix block z index

        return (
            ids.map(id => {
                const dialog = this.props.dialogs[id];
                return (
                    <React.Fragment key={id}>
                        <BodyBlocker modal onClick={this.bgClick} />
                        <Modal className="p-3 fade-in dyn-modal-dialog" key={id}>
                            {dialog.emoji || dialog.icon && <div className="pt-3" style={{ fontSize: '48px' }}>
                                {dialog.emoji || <i className={`fal fa-${dialog.icon}`} />}
                            </div>}

                            <div className="p-3" dangerouslySetInnerHTML={{ __html: dialog.message }} />

                            {dialog.buttons && <div className="p-3">
                                {dialog.buttons.map(button => (
                                    <Button className="m-1" focus key={uniqid()} {...button} onClick={() => { button.onClick(dialog) }}>{button.label}</Button>
                                ))}
                            </div>}
                        </Modal>
                    </React.Fragment>
                )
            })
        );
    }
}

const mapStateToProps = ({ dialogs }) => ({
    dialogs
});

const mapDispatchToProps = {
    dialogClose
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Dialogs);